var _path, _path2, _rect, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4721 33.8802C21.9931 33.959 21.5013 34 21 34C16.0294 34 12 29.9706 12 25C12 20.0294 16.0294 16 21 16C25.6326 16 29.4477 19.5002 29.9451 24.0002C30.6217 24.0036 31.297 24.0507 31.967 24.1411C31.5288 18.4674 26.7861 14 21 14C14.9249 14 10 18.9249 10 25C10 31.0751 14.9249 36 21 36C21.7095 36 22.4033 35.9328 23.0754 35.8045C22.7923 35.2025 22.5869 34.5568 22.4721 33.8802Z",
    fill: "#A79FBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8495 32.1086C40.4054 32.3739 40.9883 31.7868 40.6152 31.2967C38.1492 28.057 34.2521 25.9658 29.8665 25.9658C25.481 25.9658 21.5839 28.057 19.1179 31.2965C18.7448 31.7867 19.3277 32.3737 19.8836 32.1085C21.3516 31.4081 22.9835 30.858 24.7318 30.4906C24.4958 31.1037 24.3665 31.7696 24.3665 32.4658C24.3665 35.5034 26.8289 37.9658 29.8665 37.9658C32.9041 37.9658 35.3665 35.5034 35.3665 32.4658C35.3665 31.7697 35.2371 31.1037 35.0012 30.4907C36.7496 30.8581 38.3815 31.4082 39.8495 32.1086ZM33.3665 32.4658C33.3665 34.3988 31.7995 35.9658 29.8665 35.9658C27.9335 35.9658 26.3665 34.3988 26.3665 32.4658C26.3665 30.5328 27.9335 28.9658 29.8665 28.9658C31.7995 28.9658 33.3665 30.5328 33.3665 32.4658Z",
    fill: "#A79FBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 6,
    height: 3,
    fill: "#A79FBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25C19.5 25.8284 20.1716 26.5 21 26.5C21.8284 26.5 22.5 25.8284 22.5 25L19.5 25ZM19.5 18L19.5 25L22.5 25L22.5 18L19.5 18Z",
    fill: "#A79FBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5032 17.6152C31.1191 17.0612 31.1692 16.1127 30.6152 15.4968C30.0612 14.8809 29.1127 14.8308 28.4968 15.3848L30.5032 17.6152ZM27.9968 15.8346L26.8816 16.8377L28.888 19.0681L30.0032 18.065L27.9968 15.8346ZM28.4968 15.3848L27.9968 15.8346L30.0032 18.065L30.5032 17.6152L28.4968 15.3848Z",
    fill: "#A79FBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5607 15.4393C12.9749 14.8536 12.0251 14.8536 11.4393 15.4393C10.8536 16.0251 10.8536 16.9749 11.4393 17.5607L13.5607 15.4393ZM11.9393 18.0607L13 19.1213L15.1213 17L14.0607 15.9393L11.9393 18.0607ZM11.4393 17.5607L11.9393 18.0607L14.0607 15.9393L13.5607 15.4393L11.4393 17.5607Z",
    fill: "#A79FBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatched);
export default __webpack_public_path__ + "static/media/watched.9accaec4f9d19d9c8311a842b2e7835c.svg";
export { ForwardRef as ReactComponent };